import { useContext, useMemo } from "react";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";

export const useFilteredLegalEntityAndDealer = () => {

    const {globalData} = useContext(GlobalContext);

    const filteredLegalEntities = useMemo(() => globalData.user.legalEntities.filter((le:any) => le.market !== 'all'),[globalData.user.legalEntities]) 
    const filteredDealers = useMemo(() => globalData.user.dealers.filter((le: any) => le.legalEntities.some((entity: any) => entity.market !== 'all')), [globalData.user.dealers]);

    return {filteredLegalEntities,filteredDealers}

}